/* eslint @typescript-eslint/strict-boolean-expressions: off */

import { Icon } from "gui/icon/icon";
import { Card } from "gui/card/card";
import { SanityPopular } from "lib/sanity/types";
import { Grid } from "gui/grid/grid";
import { Subtitle } from "gui/subtitle/subtitle";

export const Popular: React.FC<{
  item: SanityPopular;
}> = (props) => {
  const id = `aria-${props.item._key}`;

  return (
    <Grid aria-labelledby={id} revealOnScroll gaps>
      <Subtitle id={id} text={props.item.title} icon="star">
        {props.item.link && props.item.more && (
          <a href={props.item.link}>
            {props.item.more}
            <Icon icon="arrow-right" />
          </a>
        )}
      </Subtitle>
      {props.item.list.map((item, i) => (
        <Card
          key={i}
          icon={item.icon}
          title={item.title}
          subtitle={item.subtitle}
          href={item.link}
        />
      ))}
    </Grid>
  );
};
